export default "__VITE_ASSET__31a1ccd4__"